import { createReducer } from './util';
import * as actionTypes from '../typedefs/actionTypes';
import * as a from '../typedefs/actions';
import { UIState as State } from '../typedefs/store';

const initialState: State = {
    leaveMessageForm: {
        submitting: false,
        submitSuccess: false,
        submitError: false,
    },
};

const handlers = {
    [actionTypes.LEAVE_MESSAGE_FORM_SUBMIT]: leaveMessageFormSubmitting,
    [actionTypes.LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS]: leaveMessageFormSubmitSuccess,
    [actionTypes.LEAVE_MESSAGE_FORM_SUBMIT_ERROR]: leaveMessageFormSubmitError,
    [actionTypes.REMOVE_CONVERSATION]: removeConversation,
};

function removeConversation(state: State, action: a.RemoveConversationAction) {
    return {
        ...state,
        leaveMessageForm: { submitting: false, submitSuccess: false, submitError: false },
    };
}

function leaveMessageFormSubmitting(state: State, action: a.LeaveMessageFormSubmitAction) {
    return {
        ...state,
        leaveMessageForm: { submitting: true, submitSuccess: false, submitError: false },
    };
}

function leaveMessageFormSubmitSuccess(
    state: State,
    action: a.LeaveMessageFormSubmitSuccessAction,
) {
    return {
        ...state,
        leaveMessageForm: { submitting: false, submitSuccess: true, submitError: false },
    };
}

function leaveMessageFormSubmitError(state: State, action: a.LeaveMessageFormSubmitFailureAction) {
    return {
        ...state,
        leaveMessageForm: { submitting: false, submitSuccess: false, submitError: true },
    };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/ui.ts